export const getCurrenciesIdsByNames = (currenciesName, currenciesData) => {
    return currenciesName?.map(currencyName => {
        const currentCurrencyData = currenciesData?.find(currencyData => {
            return currencyData.currency === currencyName;
        });

        return currentCurrencyData?.id;
    }) || [];
};
